<script>
import DeliveryRequest from './delivery-request/DeliveryRequest.vue'

const BASE_DR_STATUSES = ['brand_new', 'completed', 'service_required', 'not_collected']

const STATUS_MAP = [
  { label: 'all', statusIn: BASE_DR_STATUSES },
  { label: 'service_required', statusIn: ['service_required'] },
  { label: 'not_collected', statusIn: ['not_collected'] }
]

export default {
  name: 'DeliveryRequestWrapper',
  components: { DeliveryRequest },
  data: function () {
    return {
      status: STATUS_MAP[0].label,
      statusIn: STATUS_MAP[0].statusIn
    }
  },
  methods: {
    setStatus(status) {
      let statusObj = STATUS_MAP.find((o) => o.label == status)
      this.status = statusObj.label
      this.$emit('status-changed', statusObj.statusIn)
    }
  }
}
</script>

<template lang="pug">
.row.delivery-wrapper
  .tabs
    button.btn.btn-tab(
      type="button"
      v-ea-click="() => {setStatus('all')}"
      :class="{ active: status == 'all' }"
    ) {{ $t('support.deliveryRequests.allTabButton') }}
    button.btn.btn-tab(
      type="button"
      v-ea-click="() => {setStatus('service_required')}"
      :class="{ active: status == 'service_required' }"
    ) {{ $t('support.deliveryRequests.serviceRequiredTabButton') }}
    button.btn.btn-tab(
      type="button"
      v-ea-click="() => {setStatus('not_collected')}"
      :class="{ active: status == 'not_collected' }"
    ) {{ $t('support.deliveryRequests.notCollectedTabButton') }}

  .col-12.col-lg-6.offset-lg-3.pt-5.tab-content
    slot
</template>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';
.delivery-wrapper {
  height: 100%;
}
.tabs {
  border-bottom: 1px solid $gray-lighter;

  @media (max-width: 991.98px) {
    width: 100vw;
    height: 6vh;
  }

  .btn-tab {
    height: 8vh;
    outline: none;
    box-shadow: none;
    border-bottom: 3px solid transparent;
    border-radius: 0px;

    @media (max-width: 991.98px) {
      font-size: 1.6rem;
      padding: 1rem;
      height: 6vh;
    }

    &.active {
      color: $primary !important;
      border-bottom: 3px solid $primary !important;
    }
  }
}
.tab-content {
  height: 68vh; // 100 - 8 - (2x12)
  overflow-y: auto;

  @media (max-width: 991.98px) {
    height: 70vh; // 100 - 6 - (2x12)
  }
}
</style>
